import { AboutMe, ContactMe, HeroImage, MyWork, Resources } from '../sections'
import authContext from '../context/auth-context'
import React, { useEffect, useContext } from 'react'
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import { CartContext } from '../context/CartContext';
import axios from 'axios';
import { url } from '../constants';
const Home = () => {
  const {getBanner, getAboutMe, getContent} = useContext(authContext)
  const {setCart } = useContext(CartContext)
  const sendDataToBackend = async (data) => {
    await axios({
      url:`${url}/api/storeOrderData/`,
      headers:{"Content-Type":'application/json'},
      data:data,
      method:"POST"
    }).then(res => console.log('information stored in the backend')).catch(err => console.error(err))
  }
  useEffect(()=>{
    getBanner()
    getAboutMe()
    getContent()
    const successInQuery = window.location.href.includes('success=true')
    if(successInQuery){
      const cart = localStorage.getItem("cart")
      const formData = localStorage.getItem("formData")
      const userInfo = localStorage.getItem("userInfo")
      localStorage.removeItem('cart')
      toast(`Ordered Placed Successfully !`, {
        position: "bottom-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      sendDataToBackend({cart,formData, userInfo})
      setTimeout(()=>{
        window.location.replace('/')
      }, 2000)
    }
    // eslint-disable-next-line

    // get the cart items from the localstorage
    let cartItems = localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : []
    setCart(cartItems)
  // eslint-disable-next-line
  },[])
  return (
    <>
    <HeroImage />
    <AboutMe />
    <MyWork />
    <Resources />
    <ContactMe />
    <ToastContainer
        position="bottom-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        style={{textAlign:'center'}}
        />
    </>
  )
}

export default Home